// extracted by mini-css-extract-plugin
export default {"codeBlock":"CodeBlock--codeBlock--flTGc","floatingCopyButton":"CodeBlock--floatingCopyButton--7JIKz"};